module.exports = __webpack_public_path__ + "img/brain.52ea1a9f.png";